// El QR del gafete contiene solo el folio (por defecto) y llega tal cual a la búsqueda. Si se
// configura en JSON {"folio":"CF0003","nombre":"..."} (LabelPrinter.tsx), el lector lo "teclea"
// completo: si el término trae un folio etiquetado así, se busca solo por el folio;
// cualquier otro término se deja igual.
export function extractFolioFromScan(term: string): string {
  const trimmed = term.trim()
  if (!/folio/i.test(trimmed)) return term

  try {
    const data = JSON.parse(trimmed)
    if (data && typeof data === "object" && data.folio) return String(data.folio).trim()
  } catch {
    // JSON incompleto o con símbolos cambiados por la distribución del teclado del lector
  }

  // "folio":"CF0003", folio=CF0003, ¨folio¨Ñ¨CF0003¨, folioCF0003…
  const match = trimmed.match(/folio[^A-Za-z0-9]*([A-Za-z]{2,}\d+)/i)
  return match ? match[1].toUpperCase() : term
}
